import { render, staticRenderFns } from "./PackagesProduct.vue?vue&type=template&id=7c98455e&"
import script from "./PackagesProduct.vue?vue&type=script&lang=js&"
export * from "./PackagesProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports